export default __webpack_public_path__ + "static/media/MedVR-Logo.9beac093.png";